import { render, staticRenderFns } from "./RenewEn.vue?vue&type=template&id=d0dd7146&scoped=true&"
var script = {}
import style0 from "./RenewEn.vue?vue&type=style&index=0&id=d0dd7146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0dd7146",
  null
  
)

export default component.exports